// Shared helpers used by both admin and tenant KB UIs. Kept tiny on purpose
// — pages that need more (icons, layouts) import from their own sub-tree.

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EMPTY_KB = {
  name: '',
  call_type: '',
  description: '',
  threshold_score: 70,
  escalation_emails: [],
  criteria: [],
  subtypes: [],
  grading_instructions: '',
};

export const EMPTY_CRITERION = { description: '', weight: 1 };

// Roles allowed to write KBs from the tenant portal.
export const CAN_WRITE_ROLES = new Set(['master_admin', 'domain_admin', 'domain_supervisor']);

// Pull the cleanest human-readable message out of an axios/fetch error.
export const extractErr = (err, fallback) => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  if (err?.response?.status) return `${fallback} (HTTP ${err.response.status})`;
  return err?.message ? `${fallback}: ${err.message}` : fallback;
};

export const fmtHistoryDate = (iso) => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch { return iso.slice(0, 16).replace('T', ' '); }
};
